import { memo } from 'react';

function Key() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.3333 6.11111C13.1924 6.11111 13.8889 6.80756 13.8889 7.66667M17 7.66667C17 10.244 14.9107 12.3333 12.3333 12.3333C11.8619 12.3333 11.4067 12.2634 10.9777 12.1334L9.22222 13.8889H7.66667V15.4444H6.11111V17H3.77778C3.34822 17 3 16.6518 3 16.2222V14.2111C3 14.0048 3.08194 13.8069 3.22781 13.6611L7.86661 9.02228C7.73658 8.59327 7.66667 8.13813 7.66667 7.66667C7.66667 5.08934 9.756 3 12.3333 3C14.9107 3 17 5.08934 17 7.66667Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(Key);
